// @ts-nocheck
// TODO: bring back with GetMarketChanges with new API
import { get } from 'lodash-es'
import { connect } from 'react-redux'
import { GetMarketChanges } from '#/store/actions/property'
import MarketCondition from './MarketCondition'

const mapStateToProps = (state: TopHap.StoreState) => ({
  isMobile: state.global.isMobile.any,
  filterOptions: get(state.preferences.filter, 'filters.0.subfilters')
})
const mapDispatchToProps = { getMarketChanges: GetMarketChanges }

export default connect(mapStateToProps, mapDispatchToProps)(MarketCondition)
